export const isLocalEnvironment = (): boolean => window.location.hostname === "localhost";
